// Core
import { NavigationGuard } from "vue-router";
import router from "@/router";

// Stores
import pinia from "@/store/pinia";

// Services & Helpers
import { analyticsSetUser } from "@/core/services/analyticsService";
import { projectAuth } from "@/firebase/config";
import { sentryService } from "@/core/services/sentry/sentryService";

// Stores
import { useUserStore } from "@/store/user";

const requireAuth: NavigationGuard = async (to, _from, next) => {
  try {
    const userStore = useUserStore(pinia);

    const refresh = projectAuth.currentUser?.refreshToken;

    if (!refresh) {
      next({ name: "login" });
    } else {
      if (userStore.userInfos && to.fullPath !== "/sign-up" && to.fullPath !== "/login") {
        analyticsSetUser(userStore.userInfos);
      }

      next();
    }
  } catch (error) {
    // Capturar erro no Sentry antes de redirecionar
    sentryService.captureError(
      error,
      "auth-guard-error",
      {
        title: "Erro na autenticação",
        message: error instanceof Error ? error.message : "Erro desconhecido ao verificar autenticação"
      },
      {
        guard: "requireAuth",
        to: to.fullPath,
        from: _from.fullPath,
        error_source: "router"
      }
    );
    
    // Cancel current navigation and redirect to error page without triggering guards
    next(false);
    router.replace({ name: "500" });
  }
};

export default requireAuth;
